// material-ui
import { Box, IconButton } from "@mui/material";
import Button from "@mui/material/Button";
import * as React from "react";
import { useHistory } from "react-router-dom";
import OpenMenuIcon from "../../../../assets/images/icons/sideMenu/openMenuIcon";
import { getRouteUrl } from "../../../../helpers/getRouteUrl";
import useMenuAction from "../../../../hooks/menu/useMenuAction";
import useMenuData from "../../../../hooks/menu/useMenuData";
import { ROUTE_PAGE_HOME } from "../../../../routers/routes";
import Logo from "../../logo/logo";
import DrawerHeaderStyled from "./drawerHeaderStyled";

// ==============================|| DRAWER HEADER ||============================== //

const DrawerHeader = ({ open }) => {
	const { setDrawerOpen } = useMenuAction()
	const { drawerOpen } = useMenuData()
	const history = useHistory()
	return (
		<DrawerHeaderStyled
			open={open}
			sx={{
				minHeight: '98px',
				width: 'inherit',
				paddingTop: '8px',
				paddingBottom: '8px',
				paddingLeft: open ? '24px' : 0,
				backgroundColor: '#FFFFFF',
				justifyContent: drawerOpen ? 'start' : 'center'
			}}
		>
			{!drawerOpen ? (
				<Box>
					<Box>
						<IconButton
							onClick={() => {
								setDrawerOpen(true)
							}}
							sx={{
								display: 'flex',
								padding: '24px',
								alignItems: 'center',
								justifyContent: 'center',
								'&:hover': {
									background: 'none'
								}
							}}
						>
							<OpenMenuIcon/>
						</IconButton>
					</Box>
					<Box>
						<Button
							variant={'text'}
							sx={{
								padding: 0, // Αφαιρεί περιττά padding
								paddingLeft: 0.5,
								minWidth: "unset", // Κάνει το button να "αγκαλιάζει" το λογότυπο
							}}
							onClick={(e) => {
								e.stopPropagation()
								history.push(getRouteUrl(ROUTE_PAGE_HOME))
							}}
						>
							<Logo width={83} height={34}/>
						</Button>
					</Box>
				</Box>
			) : (
				<Box
					sx={{
						padding: '2rem',
						paddingBottom: 0
					}}
				>
					<Button
						variant={'text'}
						sx={{
							padding: 0, // Αφαιρεί περιττά padding
							minWidth: "unset", // Κάνει το button να "αγκαλιάζει" το λογότυπο
						}}
						onClick={(e) => {
							e.stopPropagation()
							history.push(getRouteUrl(ROUTE_PAGE_HOME))
						}}
					>
						<Logo/>
					</Button>
				</Box>
			)}
		</DrawerHeaderStyled>
	);
};

// DrawerHeader.propTypes = {
//     open: PropTypes.bool
// };

export default DrawerHeader;
